import { useDisclosure } from '@chakra-ui/react/hooks';
import { useCallback, useContext } from 'react';

import useFreeBuildsShow from '@/client/BFF/Workspaces/FreeBuilds/useFreeBuildsShow';
import { GlobalPropsContext } from '@/components/page/GlobalPropsContext';
import { GlobalProps } from '@/models/GlobalProps';

const useRestrictedPlanBuildUpsell = () => {
  const { account } = useContext(GlobalPropsContext) as GlobalProps;
  const { open, onOpen, onClose } = useDisclosure();

  const { data: freeBuilds, isLoading } = useFreeBuildsShow(
    { workspaceSlug: account?.slug || '' },
    { enabled: Boolean(account?.isRestricted) },
  );

  const shouldShowUpsell = Boolean(account?.isRestricted && freeBuilds?.available === false);

  const guardBuildAction = useCallback(
    (action: () => void) => {
      if (isLoading) {
        return;
      }

      if (shouldShowUpsell) {
        onOpen();
      } else {
        action();
      }
    },
    [isLoading, shouldShowUpsell, onOpen],
  );

  return {
    isUpsellDialogOpen: open,
    onUpsellDialogOpen: onOpen,
    onUpsellDialogClose: onClose,
    organizationSlug: account?.slug || '',
    isLoading,
    shouldShowUpsell,
    guardBuildAction,
  };
};

export default useRestrictedPlanBuildUpsell;
